export default "__VITE_ASSET__Cnk4672S__"